import { setupWorker, type SetupWorker } from "msw/browser";
import handlers from "./handlers";

const worker: SetupWorker = setupWorker(...handlers);

console.table(worker.listHandlers());

export default worker;
